// Facade del client de `retail-wizard-business` — el módulo /wizard del vendedor.
//
// 🔴 **NO HAY ADAPTER MOCK, y no se vuelve a agregar.** El wizard captura una VENTA real: un
// adapter de muestra acá no solo pinta números falsos, deja creer que una venta se cerró.
import { wizardClient } from './retail-wizard.client';

export const wizardApi = wizardClient;

export type { CancelSessionResult, WizardApi, WizardSessionCancel } from './contract';
